import type { ButtonStyle, ModalTrigger } from './types'

export const SUPPORTED_ACTIONS: readonly string[] = ['url', 'webview', 'deeplink', 'close']
export const MODAL_ACTIONS_HEADER = SUPPORTED_ACTIONS.join(',')

export const SUPPORTED_TRIGGERS: readonly ModalTrigger[] = [
  'web_home_enter',
  'web_course_view_enter',
  'web_course_day_enter'
]

export const BUTTON_STYLES: readonly ButtonStyle[] = ['active', 'secondary', 'ghost_stroke', 'ghost', 'alert', 'warning']

// Сколько ждать картинку, прежде чем показать текст и кнопки с плейсхолдером.
export const IMAGE_TIMEOUT_MS = 1500

// Сколько очередь ждёт список правил. Дольше — DAY-1 и страницы не ждут серверную модалку;
// сам запрос не отменяется, поздний ответ пригодится следующим триггерам.
export const RULES_HOLD_TIMEOUT_MS = 4000

export const DAY_MS = 24 * 60 * 60 * 1000
